import { Fragment } from 'react';
import { CSSTransition } from 'react-transition-group';
import { rage, useObservable } from '~/rage';
import { useLayoutSelector } from '../../redux';
import { InventoryExchange } from '../InventoryExchange';
import { InventoryExchangeComfirmation } from '../InventoryExchangeComfirmation';
import { InventoryExchangeFinishScreen } from '../InventoryExchangeFinishScreen';
import { InventoryMain } from '../InventoryMain';

const Inventory = () => {
	const isExchange = useObservable(rage.inventory.getIsExchange());
	const { confirmationVisible, finishScreenVisible } = useLayoutSelector(
		(state) => state.inventory,
	);

	if (isExchange) {
		return (
			<Fragment>
				<InventoryExchange />
				<CSSTransition
					in={confirmationVisible}
					timeout={300}
					classNames="confirm"
					unmountOnExit
				>
					<InventoryExchangeComfirmation />
				</CSSTransition>
				<CSSTransition
					in={finishScreenVisible}
					timeout={300}
					classNames="finish"
					unmountOnExit
				>
					<InventoryExchangeFinishScreen />
				</CSSTransition>
			</Fragment>
		);
	}

	return <InventoryMain />;
};

export { Inventory };
